import React from 'react';
import "./About.css"

function About(props) {
  return (
    <div>
        <h1 className="h1">Hola about us</h1>
    </div>
  );
}

export default About;
